export default {
  title: 'The site uses cookies',
  body: 'Our cookies are there to make it easier for you to use our website. They allow us to recognise our registered users, count visitor numbers and help us understand how they use our site. This helps us make changes so you can find what you are looking for faster.',
  url: 'https://www.schemeserve.com',
};
